"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataState = void 0;
const React = __importStar(require("react"));
const antd_1 = require("antd");
const EventsPopover_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/help/EventsPopover");
const PageContent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/content/PageContent"));
const EventsFormComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/state/data/EventsFormComponent");
const EventsPage_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/EventsPage");
const EventsHighchartsComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/state/data/EventsHighchartsComponent");
const EventsChartSettingsComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/state/data/EventsChartSettingsComponent");
const EventsPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/EventsPageDataProvider");
const EventsPageModelProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/EventsPageModelProvider");
const react_router_dom_1 = require("react-router-dom");
const EventsExportHighchartsButton_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/state/data/EventsExportHighchartsButton");
const EventsPageHighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/state/data/EventsPageHighchartsOptionsProvider");
const react_1 = require("react");
const Analytics_1 = require("src/hello_assets/src/util/analytics/Analytics");
exports.DataState = React.memo(() => {
    (0, react_1.useEffect)(() => {
        Analytics_1.Analytics.trackViewEvents();
    }, []);
    return React.createElement(React.Fragment, null,
        React.createElement(EventsPageHighchartsOptionsProvider_1.EventsPageHighchartsOptionsProvider, null,
            React.createElement(antd_1.PageHeader, { title: React.createElement(antd_1.Space, null,
                    React.createElement(React.Fragment, null, EventsPage_1.PAGE_TITLE),
                    React.createElement(EventsPopover_1.EventsPopover, null)), extra: React.createElement(EventsExportHighchartsButton_1.EventsExportHighchartsButton, null) }),
            React.createElement(PageContent_1.default, null,
                React.createElement(PageContent_1.default.Card, null,
                    React.createElement(EventsChartSettingsComponent_1.EventsChartSettingsComponent, null),
                    React.createElement(EventsHighchartsComponent_1.EventsHighchartsComponent, null)),
                React.createElement(PageContent_1.default.CardSpacer, null),
                React.createElement(PageContent_1.default.Card, null,
                    React.createElement(antd_1.Row, null,
                        React.createElement(antd_1.Col, { span: 24 },
                            React.createElement(EventsFormComponent_1.EventsFormComponent, null)))),
                process.env.NODE_ENV === "development" ? React.createElement(DebugView, null) : null)));
});
const DebugView = () => {
    const pageDataContext = (0, EventsPageDataProvider_1.useEventsPageDataContext)();
    const pageModelContext = (0, EventsPageModelProvider_1.useEventsPageModelContext)();
    const location = (0, react_router_dom_1.useLocation)();
    return React.createElement(React.Fragment, null,
        React.createElement(PageContent_1.default.CardSpacer, null),
        React.createElement(PageContent_1.default.Card, null,
            React.createElement(antd_1.Row, { gutter: [16, 16] },
                React.createElement(antd_1.Col, { span: 24 },
                    "location:",
                    React.createElement("br", null),
                    React.createElement("span", { style: { fontSize: "10px", maxHeight: 180, wordBreak: "break-all" } }, decodeURI(location.search))),
                React.createElement(antd_1.Col, { span: 8 },
                    "pageModelFormState:",
                    React.createElement("br", null),
                    React.createElement("pre", { style: { fontSize: "10px", maxHeight: 250 } }, JSON.stringify(pageModelContext.pageModelFormState, null, 4))),
                React.createElement(antd_1.Col, { span: 8 },
                    "dataURLState:",
                    React.createElement("br", null),
                    React.createElement("pre", { style: { fontSize: "10px", maxHeight: 250 } }, JSON.stringify(pageDataContext.urlState, null, 4))),
                React.createElement(antd_1.Col, { span: 8 },
                    "dataState:",
                    React.createElement("br", null),
                    React.createElement("pre", { style: { fontSize: "10px", maxHeight: 250 } }, JSON.stringify(pageDataContext.state, null, 4)))),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null)));
};
